import React, { useRef } from "react";
import { Paperclip, X } from "lucide-react";

const MAX_BYTES = 5 * 1024 * 1024; // 5 MB per file

function fileToAttachment(file) {
  return new Promise((resolve, reject) => {
    if (file.size > MAX_BYTES) {
      reject(new Error(`${file.name} is larger than 5 MB`));
      return;
    }
    const r = new FileReader();
    r.onload = () => {
      // result is "data:<type>;base64,<data>"
      const b64 = String(r.result).split(",")[1] || "";
      resolve({
        filename: file.name,
        content_type: file.type || "application/octet-stream",
        file_data: b64,
        file_size: file.size,
      });
    };
    r.onerror = () => reject(r.error);
    r.readAsDataURL(file);
  });
}

export default function AttachmentUpload({ value = [], onChange }) {
  const inputRef = useRef(null);

  async function pick(e) {
    const files = Array.from(e.target.files || []);
    try {
      const adds = await Promise.all(files.map(fileToAttachment));
      onChange?.([...(value || []), ...adds]);
    } catch (err) {
      alert(err.message || "Upload failed");
    } finally {
      if (inputRef.current) inputRef.current.value = "";
    }
  }
  function remove(idx) {
    onChange?.(value.filter((_, i) => i !== idx));
  }

  return (
    <div>
      <label className="label flex items-center gap-1"><Paperclip size={14} /> Attachments <span className="text-xs text-gray-400 font-normal">(optional, ≤5 MB each)</span></label>
      <input ref={inputRef} type="file" multiple onChange={pick} className="block w-full text-sm text-gray-700 file:mr-3 file:py-1 file:px-3 file:rounded file:border-0 file:bg-brand-500 file:text-white file:cursor-pointer hover:file:bg-brand-600" />
      {value.length > 0 && (
        <ul className="mt-2 space-y-1">
          {value.map((a, i) => (
            <li key={i} className="flex items-center justify-between text-sm bg-gray-50 px-2 py-1 rounded">
              <span className="truncate">{a.filename} <span className="text-xs text-gray-400">({Math.round((a.file_size || 0) / 1024)} KB)</span></span>
              <button type="button" onClick={() => remove(i)} className="text-red-500 hover:text-red-700"><X size={14} /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
